import AudioManager from "../../Shared/AudioManager";
import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import { Global } from "../../Shared/Global";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {

    @property(cc.EditBox)
    editBox: cc.EditBox = null;

    @property(cc.Button)
    btnSubmit: cc.Button = null;



    start() {

    }

    updateUI(list) {
        this.editBox.placeholder = i18n.t('Task.friends_account');
        this.editBox.string = ""
        this.btnSubmit.clickEvents[0].customEventData = list.id;
    }

    onBtnClose(event, param) {
        AudioManager.playSound("close")
        this.node.active = false;
    }

    onBtnSubmit(event, param) {
        AudioManager.playSound("button");
        if (!this.editBox.string) {
            UIManager.showToastUI(i18n.t('Task.inp_account'));
            return;
        }
        let data2 = {
            taskId: param,
            friendUserId: this.editBox.string
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentApplicationReward(data2, function (rec) {
            UIManager.hideLoadingUI();
            //cc.director.emit(Global.UserEvent.UpdateShareTaskBtn,parseInt(param));
            this.node.active = false;
            UIManager.showTipUI(i18n.t('datum_text.apply_succ'));

        }.bind(this), function () {
            console.log("=====提交错误")
        })

    }

}
